import { authApi } from '@/lib/api/auth';
import { getLoginPath } from '@/lib/api/config';

export function getLogoutRedirectUrl(): string {
  const q = 'logout=1';
  const base = getLoginPath();
  return base.includes('?') ? `${base}&${q}` : `${base}?${q}`;
}

export async function performLogoutAndRedirect(): Promise<void> {
  try {
    await authApi.logout();
  } catch {
    /* empty */
  }
  window.location.href = getLogoutRedirectUrl();
}
